/**
 * Action permettant de binder les teams de l'utilisateur
 * @type {string}
 */
export const TEAMS_BIND_TEAMS = 'bindTeams'
